import * as moment from "moment"
import { Moment } from "moment"

export class PagingSearch {
    page: number = 1
    rows: number = 10
    sort: string = "regDate"
    direction: string = "desc"
    keyword: string
    fromDate: Moment = moment()
    toDate: Moment = moment()
}

export class Pagination{
    constructor(resData:any) {
        this.totalPageCount = resData.totalPages    // total page count
        this.totalRows = resData.totalElements      // toal list size
        this.rows = resData.size                    //rows
        this.page = resData.number + 1              //current page (0부터)
    }
    totalPageCount: number = 0
    totalRows: number = 0 
    rows: number = 50
    page: number = 1
    listSize: number = 0
}

export class Code {
    code: string
    codeName: string
    codeGrp: string
    codeGrpName: string
    codeOrd: number
    codeOrdinal: number
    codeType: string
    codeTypeName: string
    description: string
}
export class RefererGroupCode {
    refererGroupCode: string
    refererGroupName: string
    refererGroupUrl: string
    seq: number
}